<template>
    <page-content>
        <div slot="header">
            <h4 class="moduldTit" v-if="isOpen">互评分数填写</h4>
            <h4 class="moduldTit" v-if="!isOpen">该功能暂未开放</h4>
        </div>
        <div slot="content">
            <div class="evaluationsBox" v-loading="loading">
                <p class="evaluationsTips" v-if="!evaluationsLoad && evaluations.length == 0 && isOpen">{{loading?'加载互评对象中......':'暂无互评对象'}}</p>
                <div v-if="evaluations.includes('同事互评')" class="evalBox">
                    <h5>同事互评</h5>
                    <div v-show="isOpen">
                        <div v-for="(colleagueData,index) in colleagueDatas" :key="colleagueData.colleague_id" class="evalItemBox">
                            <div class="formItem"><label>本期考核对象:</label><span>{{colleagueData.status == 1 ? colleagueData.examiner+'(本期不参加互评)' :colleagueData.examiner}}</span></div>
                            <div class="formItem"><label>考核周期:</label><span>{{colleagueData.period}}</span></div>
                            <div class="formItem" v-if="colleagueData.status != 1">
                                <el-checkbox v-model="colleagueData.isWorkHandover" :disabled="isConfirm[1][index]">有工作交接</el-checkbox>
                            </div>
                            <template v-if="colleagueData.isWorkHandover && colleagueData.status != 1">
                                <div class="formItem" v-for="item in colleagueData.items" :key="item.id">
                                    <label>{{item.item_name}}({{item.max_score}}分):</label>
                                    <el-input v-model="item.score" size="mini" :disabled="isConfirm[1][index]" type="number" class="input" min="0" :max="item.max_score"></el-input>
                                    <!-- <label>({{item.max_score}}分)</label> -->
                                </div>
                            </template>
                            <div class="formItem" v-if="!colleagueData.isWorkHandover && colleagueData.status != 1">
                                <label>{{colleagueData.item.name}}({{colleagueData.impression}}分):</label>
                                <el-input v-model="colleagueData.item.val" :disabled="isConfirm[1][index]" size="mini" class="input" type="number" min="0" :max="colleagueData.impression"></el-input>
                                <!-- <label>({{colleagueData.items[0].max_score}}分)</label> -->
                            </div>
                            <div class="formItem" style="margin-right:0" v-if="colleagueData.status != 1">
                                <el-button type="primary" @click="saveMutualEvaluation(colleagueData,'colleagueData')" v-if="!isConfirm[1][index]" size="mini">保存</el-button>
                                <el-button type="primary" @click="submitData(colleagueData,'colleagueData',1,index)" :loading="isConfirm[1][index]" v-if="!isConfirm[1][index]" size="mini">提交</el-button>
                            </div>
                        </div>
                        <div v-for="(item,index) in nextColleagueDatas" :key="index" class="next-span-fontsize">下期考核对象：{{item.colleague_name}}</div>
                        <div v-if="nextColleagueDatas.length === 0"  class="next-span-fontsize">下期考核对象：无</div>
                    </div>
                    <div v-show="!isOpen">
                        <div v-for="item in colleagueDatas" :key="item.colleague_id" class="next-span-fontsize">本期考核对象：{{item.status == 1 ? item.examiner+'(本期不参加互评)' :item.examiner}}</div>
                        <div v-for="(item,index) in nextColleagueDatas" :key="index" class="next-span-fontsize">下期考核对象：{{item.colleague_name}}</div>
                        <div v-if="nextColleagueDatas.length === 0"  class="next-span-fontsize">下期考核对象：无</div>
                    </div>
                </div>
                <div v-if="evaluations.includes('组员评专员')" class="evalBox">
                    <h5>组员评专员</h5>
                    <div v-show="isOpen">
                        <div v-for="(commissionerData,index) in commissionerDatas" :key="commissionerData.colleague_id" class="evalItemBox">
                            <div class="formItem"><label>本期考核对象:</label><span>{{commissionerData.examiner}}</span></div>
                            <div class="formItem"><label>考核周期:</label><span>{{commissionerData.period}}</span></div>
                            <div class="formItem" v-for="item in commissionerData.items" :key="item.id">
                                <label>{{item.item_name}}({{item.max_score}}分):</label>
                                <el-input v-model="item.score" :disabled="isConfirm[3][index]" type="number" size="mini" class="input" min="0" :max="item.max_score"></el-input>
                                <label style="display: none;">{{isConfirmStatus}}</label>
                            </div>
                            <div class="formItem">
                                <el-button type="primary" @click="saveMutualEvaluation(commissionerData,'commissionerData')" v-if="!isConfirm[3][index]" size="mini">保存</el-button>
                                <el-button type="primary" @click="submitData(commissionerData,'commissionerData',3,index)" v-if="!isConfirm[3][index]" size="mini">提交</el-button>
                            </div>
                        </div>
                    </div>
                    <div v-show="!isOpen">
                        <span v-for="(item,index) in commissionerDatas" :key="index" class="next-span-fontsize">本期考核对象:{{item.examiner}}</span>
                    </div>
                </div>
                <div v-if="evaluations.includes('组员评组长')" class="evalBox">
                    <h5>组员评组长</h5>
                    <div v-show="isOpen">
                        <div v-for="(memberData,index) in memberDatas" :key="memberData.colleague_id" class="evalItemBox">
                            <div class="formItem"><label>本期考核对象:</label><span>{{memberData.examiner}}</span></div>
                            <div class="formItem"><label>考核周期:</label><span>{{memberData.period}}</span></div>
                            <div class="formItem" v-for="item in memberData.items" :key="item.id">
                                <label>{{item.item_name}}({{item.max_score}}分):</label>
                                <el-input v-model="item.score" :disabled="isConfirm[2][index]" size="mini" type="number" class="input" min="0" :max="item.max_score"></el-input>
                                <!-- <label>({{item.max_score}}分)</label> -->
                            </div>
                            <div class="formItem">
                                <el-button type="primary" @click="saveMutualEvaluation(memberData,'memberData')" v-if="!isConfirm[2][index]" size="mini">保存</el-button>
                                <el-button type="primary" @click="submitData(memberData,'memberData',2,index)" v-if="!isConfirm[2][index]" size="mini">提交</el-button>
                            </div>
                        </div>
                    </div>
                    <div v-show="!isOpen">
                        <span v-for="(item,index) in memberDatas" :key="index" class="next-span-fontsize">本期考核对象:{{item.examiner}}</span>
                    </div>
                </div>
            </div>
        </div>
    </page-content>
</template>
<script>
import pageContent from '@/components/pageContent'
import {computeAssessDate} from '@/assets/js/date'
export default {
    data(){
        return{
            evaluations: [],
            colleagueDatas: [],                 // 评同事数据
            commissionerDatas: [],              // 评专员数据
            memberDatas: [],                    // 评组长数据
            nextColleagueDatas: [],             // 下一期评同事数据
            getcolleagueDatasLoad: false,
            getcommissionerDatasLoad: false,
            getmemberDatasLoad: false,
            isOpen:true,                        //功能是否开放
            isConfirm:[],                       //是否已提交
            loading:false,
            isConfirmStatus: false
        }
    },
    created(){
        if(this.$store.state.login.userinfo){
            this.getIsOpen();
        }
    },
    computed:{
        evaluationsLoad: function(){
            if(this.getcolleagueDatasLoad || this.getcommissionerDatasLoad || this.getmemberDatasLoad){
                return true;
            }else {
                return false;
            }
        }
    },
    methods:{
        initData(index=1){
            this.getScoreEvaluation('assessment/getColleagueEvaluation','colleague',1); //获取该员工的互评
        },
        // 获取互评数据
        getScoreEvaluation(url,type,index){
            let date = this.handleAssessDate();
            let params = {
                start: date[0],
                end: date[1],
            };
            if(type == 'colleague'){
                this.getcolleagueDatasLoad = true;
            }else if(type == 'teamLeader'){
                this.getmemberDatasLoad = true;
            }else if(type == 'commissioner'){
                this.getcommissionerDatasLoad = true;
            }
            this.$http.get(url,{params:params}).then((res)=>{
                if(res.status === 200){
                    if(res.data.status){
                        if(type == 'colleague'){
                            this.evaluations.push('同事互评');
                            let loadData = res.data.data;
                            this.colleagueDatas = this.handleTestData(loadData,'WorkHandover','2');
                            this.getisConfirmData(this.colleagueDatas,1)
                        }else if(type == 'teamLeader'){
                            this.evaluations.push('组员评组长');
                            let loadData = res.data.data;
                            this.memberDatas = this.handleTestData(loadData,null,'4');
                            this.getisConfirmData(this.memberDatas,2)
                        }else if(type == 'commissioner'){
                            this.evaluations.push('组员评专员');
                            let loadData = res.data.data;
                            this.commissionerDatas = this.handleTestData(loadData,null,'5');
                            this.getisConfirmData(this.commissionerDatas,3)
                        }
                    }
                    if(index<3){ //顺序调用
                        if(index === 1){
                            this.getScoreEvaluation('assessment/getTeamLeaderEvaluation','teamLeader',index+1);         //获取组员评组长
                        }else if(index === 2){
                            this.getScoreEvaluation('assessment/getCommissionerEvaluation','commissioner',index+1);     //获取组员评专员
                        }
                    }
                    if(index>=3) this.getTheNext('assessment/getColleagueEvaluation')                                 //下一期考核人员
                }
                if(type == 'colleague'){
                    this.getcolleagueDatasLoad = false;
                }else if(type == 'teamLeader'){
                    this.getmemberDatasLoad = false;
                }else if(type == 'commissioner'){
                    this.getcommissionerDatasLoad = false;
                }
                
            }).catch((err)=>{
                if(type == 'colleague'){
                    this.getcolleagueDatasLoad = false;
                }else if(type == 'teamLeader'){
                    this.getmemberDatasLoad = false;
                }else if(type == 'commissioner'){
                    this.getcommissionerDatasLoad = false;
                }
            })
        },
        getTheNext(url){   //获得下一期
            this.$http.get(url,{params:{
                start:computeAssessDate()[1].split('/')[0],
                end:computeAssessDate()[1].split('/')[1],
            }}).then(v=>{
                if(v.status === 200 && v.data.status){
                    this.nextColleagueDatas=v.data.data;
                }
                this.loading=false;
            }).catch(v=>{this.loading=false;})
        },
        getisConfirmData(data,type){             //查询是否提交, 1-同事互评 2-组员评组长 3-组员评专员
            data.forEach((v,index)=>{
                this.setisConfirmData(type,index,v.colleague_id)
            })
        },
        setisConfirmData(type,index,id){        //是否已填写
            if(typeof(this.isConfirm[type])!='object'){
                this.isConfirm[type]=[]
            }
            this.$http.get('/mutualEvaluation/isConfirm',{params:{
                start:computeAssessDate()[0].split('/')[0],
                end:computeAssessDate()[0].split('/')[1],
                colleague_id:id,
                type,
            }}).then(v=>{
                if(v.status === 200){
                    this.isConfirm[type][index]=v.data.status;
                    this.isConfirmStatus = ! this.isConfirmStatus
                //    this.$nextTick(()=>{
                //    })
                }
                
            }).catch(v=>{this.loading=false;})
        },
        // 发送互评数据
        postScoreEvaluation(url,data,index,chilIndex){
            const isConfirm=JSON.parse(JSON.stringify( this.isConfirm));
            if(url === 'assessment/saveColleagueEvaluation'){
                data.start=computeAssessDate()[0].split('/')[0];
                data.end=computeAssessDate()[0].split('/')[1];
            }else{
                data.has_work_handover=null;
            }
            this.$http.post(url,data).then((res)=>{
                if(res.status === 200 && res.data.status){
                    !index && this.$message({message: res.data.message,type:'success'})
                    !!index &&
                        this.$http.put('mutualEvaluation/confirm',{
                            start:computeAssessDate()[0].split('/')[0],
                            end:computeAssessDate()[0].split('/')[1],
                            type:index,
                            colleague_id:data.colleague_id,
                        }).then(v=>{
                            if(v.status === 200){
                                isConfirm[index].splice(chilIndex,1,v.data.status)
                                this.isConfirm=isConfirm;
                                this.$message({message: v.data.message,type:'success'});
                            }
                        }).catch(v=>{})
                }
            }).catch((err)=>{
                console.log(err)
            })
        },
        // 处理互评数据
        saveMutualEvaluation(evaluationItem,type,index,chilIndex){
            let ids = [];
            let scores = [];
            if(evaluationItem.isWorkHandover){
                for(let i=0; i<evaluationItem.items.length; i++){
                    ids.push(evaluationItem.items[i].id);
                    if(evaluationItem.items[i].score && evaluationItem.items[i].score >= 0 && evaluationItem.items[i].score <= evaluationItem.items[i].max_score){
                        try {
                            evaluationItem.items[i].score = parseFloat(evaluationItem.items[i].score)
                        } catch (error) {
                            this.$message({message: '请按要求填写分数',type:'error'})
                        }
                        scores.push(evaluationItem.items[i].score);
                    }else {
                        this.$message({message: '请按要求填写分数',type:'error'})
                        return;
                    }
                }
            }else {
                const status = evaluationItem.items.some( item => item.max_score != evaluationItem.impression) // 印象分各项是否相同
                for(let i=0; i<evaluationItem.items.length; i++){
                    ids.push(evaluationItem.items[i].id);
                    if(evaluationItem.item.val && evaluationItem.item.val >= 0 && evaluationItem.item.val <= evaluationItem.impression){
                        var evaluation = evaluationItem.items[i];
                        try {
                            evaluationItem.item.val = parseFloat(evaluationItem.item.val)
                        } catch (error) {
                            this.$message({message: '请按要求填写分数',type:'error'})
                        }
                        if(status){
                            scores.push((evaluation.max_score/evaluationItem.impression*evaluationItem.item.val).toFixed(2))
                        }else{
                            scores.push(evaluationItem.item.val);
                        }
                    }else {
                        this.$message({message: '请按要求填写分数',type:'error'})
                        return;
                    }
                }
            }
            let data = {
                ids: ids.join(),
                scores: scores.join(),
                has_work_handover:evaluationItem.isWorkHandover?1:0,
                colleague_id:evaluationItem.colleague_id || '',
                impression_score: evaluationItem.item ?  evaluationItem.item.val : '',
            }
            if(type == 'colleagueData'){
                this.postScoreEvaluation('assessment/saveColleagueEvaluation',data,index,chilIndex);
            }else if(type == 'commissionerData'){
                this.postScoreEvaluation('assessment/saveCommissionerEvaluation',data,index,chilIndex);
            }else if(type == 'memberData'){
                this.postScoreEvaluation('assessment/saveTeamLeaderEvaluation',data,index,chilIndex);
            }
        },
        submitData(evaluationItem,type,index,chilIndex){           //提交
            this.saveMutualEvaluation(evaluationItem,type,index,chilIndex)
        },
        // 整理时间格式
        handleAssessDate(){
            const assessDate = computeAssessDate();
            let date = assessDate[0].split('/');
            return date;
        },
        // 整理互评数据格式
        handleTestData(arrayData,type,index){
            const assessDate = computeAssessDate();
            let date = assessDate[0].split('/');
            let resData = []
            for(let i = 0;i<arrayData.length;i++){
                if(type == 'WorkHandover'){
                    resData.push({
                        period: `${date[0]}-${date[1]}`,
                        examiner: arrayData[i].colleague_name,
                        isWorkHandover:arrayData[i].has_work_handover == null ? true : !!arrayData[i].has_work_handover,
                        // item: {name:'印象分',val: this.setArrayDataItems(arrayData[i].items,!!arrayData[i].has_work_handover,index)},
                        item: {name:'印象分',val: arrayData[i].has_work_handover == 0 ? arrayData[i].impression_score : ''},
                        items: this.setArrayDataItems(arrayData[i].items,true,index),
                        colleague_id:arrayData[i].colleague_id,
                        status:arrayData[i].status,
                        impression:this.setImpressionScore(arrayData[i].items)
                    })
                }else {
                    resData.push({
                        period: `${date[0]}-${date[1]}`,
                        examiner: arrayData[i].colleague_name,
                        isWorkHandover: true,
                        items:this.setArrayDataItems(arrayData[i].items,true,index),
                        colleague_id:arrayData[i].colleague_id,
                        status:arrayData[i].status,
                    })
                }
            }
            return resData;
        },
        // 设置印象分
        setImpressionScore(data){
            const status = data.some( item => item.max_score !== data[0]['max_score'])
            if(status){
                let score = 0
                data.forEach((item) => {
                    score += item.max_score
                })
                return score;
            }else{
                return data[0]['max_score']
            }
        },
        setArrayDataItems(arrayData,has_work_handover,type){           //渲染数据
            let param=[];
            if(has_work_handover){
                arrayData.forEach(v => {
                    const score_storage=JSON.parse(v.score_storage);
                    param.push({
                        ...v,
                        score:score_storage[type]
                    })
                });
            }else{
                param=JSON.parse(arrayData[0].score_storage)[type] || ''
            }
            return param;
        },
        getIsOpen(){    //判断功能是否开放  1-互评填写 2-考核评分表填写
            const param={
                start:computeAssessDate()[0].split('/')[0],
                end:computeAssessDate()[0].split('/')[1],
                department_id:this.$store.state.login.userinfo.department_id,
                flow_type:1,
            }
            this.loading=true;
            this.$http.get('/flow/isOpen',{params:param}).then(v=>{
                if(v.status === 200){
                    this.isOpen=v.data.status;
                    this.initData()
                }
            }).catch(v=>{this.loading=false;})
        },
    },
    components:{
        pageContent
    },
}
</script>
<style scoped>
.evaluationsBox {
    min-height: 500px;
}
.evaluationsTips {
    font-size: 14px;
    line-height: 20px;
}
.evalBox {
    margin-bottom: 30px;
    padding-left: 20px;
}
.evalBox h5{
    margin-left: -20px;
}
.evalItemBox {
    /* margin-bottom: 8px; */
    overflow: hidden;
}
.evalItemBox .formItem {
    float: left;
    /* width: 200px; */
    line-height: 34px;
    margin-right: 24px;
    font-size: 14px;
}
.evalItemBox .formItem:nth-child(1){
        min-width: 168px;
}
.formItem label {
    margin-right: 10px;
    height: 34px;
    display: inline-block;
}
.formItem span {
    display: inline-block;
    height: 34px;
    font-weight: bold;
}
.formItem .input {
    width: 80px;
}
.next-span-fontsize{
    font-size: 14px;
}
</style>
